export const insuranceProviders = ['cover_genius', 'nib', 'passport_card'];
